import { MedicationDosageTimes } from '@type';

const MEDICATION_MORNING = 6;
const MEDICATION_MIDDAY = 12;
const MEDICATION_EVENING = 18;
const MEDICATION_NIGHT = 21;
export const MEDICATION_DOSAGE_HOURS = {
  [MedicationDosageTimes.Morning]: MEDICATION_MORNING,
  [MedicationDosageTimes.Midday]: MEDICATION_MIDDAY,
  [MedicationDosageTimes.Evening]: MEDICATION_EVENING,
  [MedicationDosageTimes.Night]: MEDICATION_NIGHT,
};

export const SPECIFIC_MEDICATION_TIMINGS = [0, 8, 16, 20];
